import { render, staticRenderFns } from "./gaokaoZts.vue?vue&type=template&id=68b1a836&scoped=true"
import script from "./gaokaoZts.vue?vue&type=script&lang=js"
export * from "./gaokaoZts.vue?vue&type=script&lang=js"
import style0 from "./gaokaoZts.vue?vue&type=style&index=0&id=68b1a836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b1a836",
  null
  
)

export default component.exports